import { useEffect, useState, useContext } from "react";
import logoReel from "../../images/reel-logo-full-2.png";
import { Medication } from "./Medication";
import { background } from "./Background";
import { AppointmentInfo, HeaderInfo } from "./ExtraInfo";
import { getMedicationList } from "./utils";
import { Container } from "../../components/common-components";
import { FormContextMA } from "../../form-context";
import { MinorAilmentInfo } from "./MinorAilmentInfo";

export const Storyboard = ({ currentPage, setTotalPages }) => {
  const minorAilmentName = "Allergic Rhinitis";
  const { treatment, documentation, education } = useContext(FormContextMA);
  const [medications] = useState(getMedicationList(treatment));

  const goals = {
    personalGoals: treatment?.personalGoals ?? "",
    howToAchieveGoals: treatment?.howToAchieveGoals ?? "",
  };

  useEffect(() => {
    setTotalPages(medications.length + 1);
  }, [medications]);

  let pageContent = <></>;
  if (currentPage === 1) {
    pageContent = (
      <>
        <MinorAilmentInfo minorAilmentName={minorAilmentName} />
        {medications.length > 0 && <Medication medication={medications[0]} />}
      </>
    );
  } else if (currentPage > 1 && currentPage < medications.length + 1) {
    const medication1 = medications[currentPage - 1];
    pageContent = (
      <>{medication1 ? (<Medication medication={medication1} />) : null}</>
    );
  } else {
    pageContent = (
      <>
        <AppointmentInfo documentation={documentation} education={education} minorAilmentName={minorAilmentName} treatment={treatment} goals={goals} />
      </>
    );
  }

  return (
    <>
      <Container>
        <div className="storyboard-print-container relative flex flex-col w-full min-h-[11in] print:min-h-[11in] box-border">
          <div className="relative z-10 flex-1 min-h-0 pt-2 px-[0.42857143in] pb-[0.35in]">
            <HeaderInfo minorAilmentName={minorAilmentName} />
            {pageContent}
          </div>
          <div className="z-10 mt-auto shrink-0 w-full bg-gray-20 flex flex-col gap-[0.028571429in] items-center justify-center py-[0.071428571in] px-[0.321428571in]">
            <p className="font-normal text-[12px] text-gray-800">
              <span className="font-bold text-teal-300">
                Consumer Information Use and Disclaimer:
              </span>{" "}
              This information is a short summary of your treatment and medication. It does not include all possible details, 
              side effects, or risks that may apply to you. It is not a substitute for medical advice. 
              If your symptoms do not improve or if you have concerns, please contact your healthcare professional.
            </p>
          </div>
          {/* <div id="background" className="absolute top-0 z-0">
            {background}
          </div> */}
        </div>
      </Container>
    </>
  );
};
